const n = (v) => (typeof v === 'number' ? v : 0);

export const bucketsOf = (o) => ({
  cheapest: n(o && o.total_cheapest),
  same:     n(o && o.total_same),
  higher:   n(o && o.total_higher),
  highest:  n(o && o.total_highest),
});

export const bucketSum = (o) => {
  const b = bucketsOf(o);
  return b.cheapest + b.same + b.higher + b.highest;
};

export const isEmptyState = (profile, o) => {
  if (!o || n(o.total_products) === 0) return true;
  if (profile.viz === 'none') return false;
  return bucketSum(o) === 0;
};

export const verdictTone = (profile, o) => {
  switch (profile.verdict) {
    case 'pricePosition': {
      const total = bucketSum(o);
      if (!total) return 'gray';
      if (n(o.total_cheapest) >= total / 2) return 'green';
      if (n(o.total_higher) + n(o.total_highest) >= total / 2) return 'red';
      return 'amber';
    }
    case 'violationSummary':
      return (n(o && o.total_violated_map) + n(o && o.total_violated_mrp) + n(o && o.total_unauthorized)) > 0 ? 'red' : 'green';
    case 'profitLoss':
      return n(o && o.total_drop_shipping_loss) > 0 ? 'red' : 'green';
    default:
      return 'gray';
  }
};

export const buildActions = (profile, o) =>
  (profile.actions || [])
    .map((a) => ({
      key: a.key,
      count: typeof a.count === 'function' ? n(a.count(o)) : n(o && o[a.countField]),
      route: a.route,
      tone: a.tone,
    }))
    .filter((a) => a.count > 0);

export const deltaOf = (today, yesterday, field) => n(today && today[field]) - n(yesterday && yesterday[field]);
